'use strict'
import { default as Component } from '../component.js'
import { currentStore } from '../helper.js'

class DropdownSearchProduct extends Component
{
	init()
	{
		this.viewItems = App.View.create({ name: 'partial/component/dropdownSearchProductItems' })
		this.input = this.element.querySelector('input')
		this.dropdown = this.element.querySelector('.dropdown')
		this.menu = this.dropdown.querySelector('ul.dropdown-menu')
		this.toggle = this.dropdown.querySelector('[data-toggle="dropdown"]')
		this.timeout = null
		this.minLength = currentStore('productSearchTermMinimumLength') || 2

		document.addEventListener('action.after', e =>
		{
			if (e.detail.name != 'cartitem create' || e.detail.canceled || !e.detail.success)
				return

			this.dropdownHide()
			this.input.value = ''
			this.input.focus()
		})

		this.input.onkeyup = e => this.onKeyUp(e)
		this.input.focus()
	}

	dropdownHide = () => this.dropdown.classList.remove('open')
	dropdownShow = () => this.dropdown.classList.add('open')
	dropdownAddItems(results = [])
	{
		this.menu.innerHTML = ''
		this.viewItems.model.clear().sync({ results })

		if (!Array.isArray(results) || !results.length)
			this.viewItems.render()
		
		this.dropdownShow()
	}

	search(term)
	{
		if (this.searching)
			this.fetchController.abort()

		this.searching = true
		this.fetchController = new AbortController()

		clearTimeout(this.timeout);
		this.dropdownHide()
		this.toggle.disabled = true
		this.element.classList.add(App.cssClass.loading)

		fetch(
			'/api/v1/search?' + new URLSearchParams({ 'filter[type]': 'product', 'filter[keywords]': term, 'include': 'price' }),
			{
				signal: this.fetchController.signal
			}
		)
		.then(r =>
		{
			this.toggle.disabled = false
			this.searching = false
			return r.json()
		})
		.then(json => this.dropdownAddItems(Object.values(json?.data || {})))
		.catch(error => 
		{
			console.error(error)
			this.dropdownAddItems()
		})
		.finally(() => this.element.classList.remove(App.cssClass.loading) )
	}

	onKeyUp(e)
	{
		if (this.searching)
			this.fetchController.abort()

		if (e.key === 'Enter')
			return
		else if (e.key === 'Escape') // escape key
		{
			//e.target.value = ''
			//e.target.blur()
			this.dropdownHide()
		}
		else if (e.key === 'ArrowDown') // down arrow key
		{
			this.menu.querySelector('li a')?.focus()
			return e.preventDefault()
		}

		clearTimeout(this.timeout);
		this.dropdownHide()

		if (e.target.value.length >= this.minLength)
			this.timeout = setTimeout(() => this.search(e.target.value), 500)
	}
}

export default DropdownSearchProduct
